export * from './delete-bereich.component';
export * from './delete-bereich.component.module';